export type FootballPosition = 
    | 'GK'   // Goalkeeper
    | 'LB'   // Left Back
    | 'CB'   // Centre Back
    | 'RB'   // Right Back
    | 'LWB' // Left Wing Back
    | 'RWB' // Right Wing Back
    | 'DM'  // Defensive Midfielder
    | 'CM'   // Centre Midfielder
    | 'AM'  // Attacking Midfielder
    | 'LW'   // Left Winger
    | 'RW'   // Right Winger
    | 'S'   // Striker
    | 'CF';  // Centre Forward

export interface PositionConfig {
    code: FootballPosition;
    name: string;
    top: string;
    left: string;
    depth: 'far' | 'mid-far' | 'mid' | 'mid-near' | 'near';
}

export const POSITION_CONFIGS: PositionConfig[] = [
    // Goalkeeper (far end - smallest due to perspective)
    { code: 'GK', name: 'Goalkeeper', top: '6%', left: '50%', depth: 'far' },
    
    // Defense (back line - small markers)
    { code: 'LB', name: 'Left Back', top: '15%', left: '30%', depth: 'far' },
    { code: 'CB', name: 'Centre Back', top: '15%', left: '50%', depth: 'far' },
    { code: 'RB', name: 'Right Back', top: '15%', left: '70%', depth: 'far' },
    { code: 'LWB', name: 'Left Wing Back', top: '22%', left: '25%', depth: 'mid-far' },
    { code: 'RWB', name: 'Right Wing Back', top: '22%', left: '75%', depth: 'mid-far' },
    
    // Defensive Midfield
    { code: 'DM', name: 'Defensive Midfielder', top: '30%', left: '50%', depth: 'mid-far' },
    
    // Midfield (medium size markers)
    { code: 'LW', name: 'Left Winger', top: '38%', left: '15%', depth: 'mid' },
    { code: 'CM', name: 'Centre Midfielder', top: '38%', left: '50%', depth: 'mid' },
    { code: 'RW', name: 'Right Winger', top: '38%', left: '85%', depth: 'mid' },
    
    // Attacking Midfield
    { code: 'AM', name: 'Attacking Midfielder', top: '46%', left: '50%', depth: 'mid-near' },
    
    // Attack (largest markers due to perspective)
    { code: 'CF', name: 'Centre Forward', top: '54%', left: '50%', depth: 'mid-near' },
    { code: 'S', name: 'Striker', top: '62%', left: '50%', depth: 'near' },
];